import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { getPublicMp2Catalog } from "@/lib/public/meal-plans-v2.functions";
import { PublicMealPlanConfigurator } from "@/components/mp2/PublicMealPlanConfigurator";

export const Route = createFileRoute("/_admin/admin/meal-plans-v2-preview")({
  component: Mp2PreviewPage,
});

function Mp2PreviewPage() {
  const [selectedSlug] = useState<string | undefined>();
  
  return (
    <div className="container mx-auto px-4 py-8 max-w-6xl">
      <div className="mb-8 border-b pb-4">
        <h1 className="text-3xl font-bold font-display">Customer Configurator Preview</h1>
        <p className="text-muted-foreground">
          Preview how the Meal Plans 2.0 checkout looks for customers.
        </p>
      </div>

      <div className="bg-muted/30 rounded-xl p-8 border border-dashed border-muted-foreground/30">
        <PublicMealPlanConfigurator initialPlanSlug={selectedSlug} adminPreview key={selectedSlug} />
      </div>
    </div>
  );
}
